import {
  defer,
  distinctUntilChanged,
  fromEvent,
  map,
  Observable,
  startWith,
} from 'rxjs';

export const fromMediaQuery = (query: string): Observable<boolean> =>
  defer(() => {
    const mediaQuery = window.matchMedia(query);
    return fromEvent<MediaQueryListEvent>(mediaQuery, 'change').pipe(
      map(event => event.matches),
      startWith(mediaQuery.matches)
    );
  }).pipe(distinctUntilChanged());
